import React, { useState, useEffect } from "react";
import { useHistory, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import ConfirmDeleteModal from './ConfirmationModelDelete';
import './List.css';

const ListBrands = () => {
  const [brandsData, setBrandsData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedBrandId, setSelectedBrandId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit] = useState(10);
  const [search, setSearch] = useState("");
  const history = useHistory();

  useEffect(() => {
    const fetchBrands = async () => {
      setLoading(true);
      try {
        const response = await axios.get('https://brand.aasmo.in/api/admin/brands', {
          params: { page: currentPage, limit, search }
        });
        setBrandsData(response.data.brands);
        setTotalPages(Math.ceil(response.data.totalBrands / limit));
      } catch (error) {
        console.error("Error fetching brands:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBrands();
  }, [currentPage, limit, search]);

  const handleDownloadCSV = () => {
    const headers = [
      'S.No',
      'Name',
      'Email',
      'Area',
      'Description',
      'City',
      'Status',
      'Date',
      'Product Categories',
      'Package Title',
      'Package Price',
      'Package Amount'
    ];
  
    const csvRows = [];
    csvRows.push(headers.join(','));
  
    brandsData.forEach((brand, index) => {
      const row = [
        (currentPage - 1) * limit + index + 1,
        brand?.name || 'N/A',
        brand?.email || 'N/A',
        brand?.area || 'N/A',
        brand?.description ? brand.description.replace(/,/g, ' ') : 'N/A',
        brand?.city || 'N/A',
        brand?.status || 'N/A',
        formatDate(brand?.createdAt),
        brand?.productCategory?.map(category => category.categoryName).join(', ') || 'N/A', // Multiple categories
        brand?.packageTitle || 'N/A',
        brand?.packagePrice || 'N/A',
        brand?.packageAmount || 'N/A'
      ];
  
      csvRows.push(row.join(','));
    });
  
    const csvBlob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
    const csvUrl = URL.createObjectURL(csvBlob);
    const link = document.createElement('a');
    link.href = csvUrl;
    link.download = 'store_list.csv';
    link.click();
  };

  const handleEdit = (id) => {
    history.push(`/edit-brands/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://brand.aasmo.in/api/admin/brands/${id}`);
      setBrandsData(brandsData.filter(brand => brand._id !== id));
      setShowModal(false);
    } catch (error) {
      console.error("Error deleting brand:", error);
    }
  };

  const handleDeleteClick = (id) => {
    setSelectedBrandId(id);
    setShowModal(true);
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const truncateDescription = (description, maxLength = 50) => {
    return description && description.length > maxLength
      ? `${description.substring(0, maxLength)}...`
      : description;
  };

  const handleStatusChange = async (id, newStatus) => {
    setLoading(true);
    try {
      await axios.put(`https://brand.aasmo.in/api/admin/brands/${id}`, { status: newStatus });
      const updatedBrands = brandsData.map(brand =>
        brand._id === id ? { ...brand, status: newStatus } : brand
      );
      setBrandsData(updatedBrands);
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>List Store</h2>
          <br></br>
          <div className="d-flex justify-content-between">
            <div className="search-bar">
              <input
                type="text"
                value={search}
                onChange={handleSearchChange}
                placeholder="Search Stores..."
              />
            </div>
            <div>
              <button onClick={handleDownloadCSV} className="btn btn-primary">
                Download CSV
              </button>
            </div>
          </div>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead style={{ textAlign: "center", whiteSpace: "nowrap" }}>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Product Category</th>
                <th>Brands</th>
                <th>Package Title</th>
                <th>Package Price</th>
                <th>Package Amount</th>
             <th>Pincode</th>
                <th>Area</th>
                <th>City</th>
                <th>Status</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody style={{ textAlign: "center" }}>
              {brandsData.map((brand, index) => (
                <tr key={brand._id}>
                  <td>{(currentPage - 1) * limit + index + 1}</td>
                  <td>{brand?.name}</td>
                  <td>{brand?.productCategory?.map(category => category.categoryName).join(', ') ||''}</td> 
                  <td>{brand?.brandsNew?.name || ''}</td>
                  <td>{brand?.package?.title}</td>
                  <td>{brand?.package?.price}</td>
                  <td>{brand?.packageAmount}</td>
                  <td>{brand?.pincode}</td>
                  <td>{brand?.area}</td>
                  <td>{brand?.city || "N/A"}</td>
                  <td>
                    <select
                      value={brand?.status}
                      onChange={(e) => handleStatusChange(brand._id, e.target.value)}
                      disabled={loading}
                    >
                      <option value="pending">Pending</option>
                      <option value="approved">Approved</option>
                    </select>
                  </td>
                  <td>{formatDate(brand?.createdAt)}</td>
                  <td>
                    <i className="icon-pencil" onClick={() => handleEdit(brand?._id)}></i>
                    &nbsp;&nbsp;
                    <i className="fa fa-trash-o" onClick={() => handleDeleteClick(brand?._id)}></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Pagination Controls */}
        <div className="body">
          <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </NavLink>
              </li>
              {[...Array(totalPages).keys()].map(page => (
                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(page + 1)}
                  >
                    {page + 1}
                  </NavLink>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
        <ConfirmDeleteModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          handleConfirm={() => handleDelete(selectedBrandId)}
        />
      </div>
    </div>
  );
};

const mapStateToProps = () => ({});
export default connect(mapStateToProps, {})(ListBrands);
